module.exports = __webpack_public_path__ + "static/media/doortittle3.cf32f39a.jpeg";